<template>
  <div>
    <Sidebar/>
    <v-content>
      <TogglHours v-if="this.$store.state.dashFocus=='hours'" />
      <p v-if="this.$store.state.dashFocus=='incidentreport'">Incident Report</p>
      <CarbineProjects v-if="this.$store.state.dashFocus=='carbine-projects'" />
      <CarbineNewProject v-if="this.$store.state.dashFocus=='carbine-new-project'" />
      <p v-if="this.$store.state.dashFocus=='carbine-new-proposal'">New Proposal</p>
      <LevellingData v-if="this.$store.state.dashFocus=='levelling'" />
    </v-content>
  </div>
</template>

<script>
import Sidebar from 'components/Sidebar.vue';
import LevellingData from 'components/LevellingData.vue';
import TogglHours from 'components/TogglHours.vue';
import CarbineProjects from 'components/CarbineProjects.vue';
import CarbineNewProject from 'components/CarbineNewProject.vue';
export default {
  created: () => {
    document.title = 'ThinkSpatial | Dashboard';
  },   
  components:{
    Sidebar,
    LevellingData,
    TogglHours,
    CarbineProjects,
    CarbineNewProject
  }
}
</script>

<style>

</style>